import "@hotwired/turbo-rails"
import { mountComponents, unmountComponents } from "../vue"
import Dropzone from "../components/Dropzone.vue"
import AiAnalysisOffcanvas from "../components/AiAnalysisOffcanvas.vue"
import GuideDetailsOffcanvas from "../components/GuideDetailsOffcanvas.vue"
import StationGuidesModal from "../components/StationGuidesModal.vue"
import StepsEditor from "../components/StepsEditor.vue"
import DocumentDropzone from "../components/DocumentDropzone.vue"

const components = {
  "ai-analysis-offcanvas": AiAnalysisOffcanvas,
  dropzone: Dropzone,
  "guide-details-offcanvas": GuideDetailsOffcanvas,
  "station-guides-modal": StationGuidesModal,
  "steps-editor": StepsEditor,
  "document-dropzone": DocumentDropzone,
}

// Refresh fslightbox after Turbo navigation (loaded via CDN in the layout)
function refreshLightbox() {
  if (typeof window.refreshFsLightbox === "function") {
    window.refreshFsLightbox()
  }
}

function syncBrowserTimeZoneCookie() {
  const timeZone = globalThis.Intl?.DateTimeFormat?.().resolvedOptions().timeZone
  if (!timeZone) {
    return
  }

  const currentCookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith("browser_time_zone="))

  if (currentCookie === `browser_time_zone=${timeZone}`) {
    return
  }

  const oneYearSeconds = 60 * 60 * 24 * 365
  document.cookie = `browser_time_zone=${timeZone}; path=/; max-age=${oneYearSeconds}; samesite=lax`
}

document.addEventListener("turbo:load", () => {
  syncBrowserTimeZoneCookie()
  mountComponents(components)
  refreshLightbox()
})

document.addEventListener("turbo:render", refreshLightbox)
document.addEventListener("turbo:frame-load", refreshLightbox)

document.addEventListener("turbo:before-cache", () => {
  unmountComponents()
})
